import React from "react";

import { useTranslation } from "react-i18next";

import { useStyles } from "./styles";

const IMG = require("Assets/img/empty-state-data.svg");

interface Props {
  onlyText?: boolean;
}

export default function NoEnoughData({ onlyText = false }: Props) {
  const classes = useStyles({ onlyText });
  const { t: translate } = useTranslation();

  return (
    <div className={classes.root}>
      <div className={classes.content}>
        {!onlyText && (
          <img
            alt={translate("notEnoughData")}
            className={classes.img}
            data-cy="emptyStateDataImg"
            src={IMG}
          />
        )}
        <div className={classes.texts}>
          <div className={classes.mainText} data-cy="emptyStateDataTextMain">
            {translate("notEnoughData")}
          </div>
          <div className={classes.secondaryText} data-cy="emptyStateDataTextSecondary">
            {translate("thereIsInsufficientDataToGenerateGraphicsForTheSelectedPeriod")}
          </div>
        </div>
      </div>
    </div>
  );
}
